import { pluck } from '../../utilities'

export default class Input {

    constructor(type, fields) {
        this.type = type
        this._fields = fields
    }

    fields(variables) {
        return pluck(variables, this._fields)
    }
}